<template>
    <Transition name="d-fade" appear>
        <slot/>
    </Transition>
</template>

<style>
/*
  Note: avoid using <style scoped> here since it
  does not apply to slot content.
*/
.d-fade-enter-active,
.d-fade-leave-active {
  transition: opacity .3s ease-in-out;
}
.d-fade-enter-from,
.d-fade-leave-to {
  opacity: 0;
}
.d-fade-enter-to,
.d-fade-leave-from {
  opacity: 1;
}
</style>


